var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { loc, createCallout } from "../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import { FORMS } from "../../ion/RemediationConstants.js";
import "../internals/BaseHeader.js";
import "../internals/BaseFooter.js";
import BaseForm from "../internals/BaseForm.js";
import "../internals/BaseFormWithPolling.js";
import "../internals/BaseOktaVerifyChallengeView.js";
import BaseView from "../internals/BaseView.js";
import { createIdpButtons, createCustomButtons } from "../internals/FormInputFactory.js";
import DeviceFingerprinting from "../utils/DeviceFingerprinting.js";
import IdentifierFooter from "../components/IdentifierFooter.js";
import Link from "../components/Link.js";
import signInWithIdps from "./signin/SignInWithIdps.js";
import customButtonsView from "./signin/CustomButtons.js";
import SignInWithDeviceOption from "./signin/SignInWithDeviceOption.js";
import signInWithWebAuthn from "./signin/SignInWithWebAuthn.js";
import { isCustomizedI18nKey } from "../../ion/i18nUtils.js";
import { getForgotPasswordLink } from "../utils/LinksUtil.js";
import fn from "../../../util/CookieUtil.js";
import CustomAccessDeniedErrorMessage from "./shared/CustomAccessDeniedErrorMessage.js";
import Util from "../../../util/Util.js";
const CUSTOM_ACCESS_DENIED_KEY = "security.access_denied_custom_message";
const Body = BaseForm.extend({
  title: function() {
    return loc("primaryauth.title", "login");
  },
  save: function() {
    return loc("oform.next", "login");
  },
  initialize: function() {
    BaseForm.prototype.initialize.apply(this, arguments);
    const uiSchema = this.getUISchema();
    if (uiSchema.find((schema) => schema.name === "credentials.passcode")) {
      this.save = loc("oie.primaryauth.submit", "login");
    }
    if (this._shouldAddUsername(uiSchema)) {
      this.model.set("identifier", this.settings.get("username"));
    } else if (!this.model.get("identifier") && this._shouldApplyRememberMyUsername(uiSchema)) {
      this._applyRememberMyUsername();
    }
  },
  saveForm: function() {
    if (!this.settings.get("features.deviceFingerprinting")) {
      BaseForm.prototype.saveForm.apply(this, arguments);
      return;
    }
    const fingerprintData = {
      oktaDomainUrl: this.settings.get("baseUrl"),
      element: this.$el
    };
    this.model.trigger("request");
    DeviceFingerprinting.generateDeviceFingerprint(fingerprintData).then((fingerprint) => {
      this.options.appState.set("deviceFingerprint", fingerprint);
    }).catch(() => {
    }).finally(() => {
      BaseForm.prototype.saveForm.apply(this, arguments);
    });
  },
  render: function() {
    BaseForm.prototype.render.apply(this, arguments);
    if (this.options.appState.hasRemediationObject(FORMS.LAUNCH_AUTHENTICATOR)) {
      this.add(SignInWithDeviceOption, ".o-form-fieldset-container", false, true, {
        isRequired: false
      });
    }
    if (this.options.appState.hasRemediationObject(FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR)) {
      this.add(signInWithWebAuthn, ".o-form-fieldset-container", false, true, {
        isRequired: false
      });
    }
    const idpButtons = createIdpButtons(this.options);
    if (Array.isArray(idpButtons) && idpButtons.length) {
      this._addForgotPasswordView();
      this._addIdpView(idpButtons);
    }
    const customButtons = createCustomButtons(this.options.settings);
    if (Array.isArray(customButtons) && customButtons.length) {
      this.add(customButtonsView, {
        selector: ".o-form-button-bar",
        options: {
          customButtons,
          addSeparateLine: true
        }
      });
    }
  },
  postRender: function() {
    BaseForm.prototype.postRender.apply(this, arguments);
    this.$el.find(".identifier-container").remove();
  },
  /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */
  getUISchema: function() {
    const schemas = BaseForm.prototype.getUISchema.apply(this, arguments);
    const {
      settings
    } = this.options;
    const identifierExplainLabeli18nKey = "primaryauth.username.tooltip";
    const passwordExplainLabeli18nKey = "primaryauth.password.tooltip";
    let newSchemas = schemas.map((schema) => {
      let newSchema = __spreadValues({}, schema);
      if (schema.name === "identifier") {
        if (isCustomizedI18nKey(identifierExplainLabeli18nKey, settings)) {
          newSchema = __spreadProps(__spreadValues({}, newSchema), {
            explain: loc(identifierExplainLabeli18nKey, "login"),
            "explain-top": true
          });
        }
        newSchema = __spreadProps(__spreadValues({}, newSchema), {
          autoComplete: Util.getAutocompleteValue(this.options.settings, "username")
        });
      } else if (schema.name === "credentials.passcode") {
        newSchema = __spreadProps(__spreadValues({}, newSchema), {
          autoComplete: Util.getAutocompleteValue(this.options.settings, "current-password")
        });
        if (isCustomizedI18nKey(passwordExplainLabeli18nKey, settings)) {
          newSchema = __spreadProps(__spreadValues({}, newSchema), {
            explain: loc(passwordExplainLabeli18nKey, "login"),
            "explain-top": true
          });
        }
      }
      return newSchema;
    });
    if (this.settings.get("features.showKeepMeSignedIn") === false) {
      newSchemas = newSchemas.filter((schema) => schema.name !== "rememberMe");
    }
    return newSchemas;
  },
  showCustomFormErrorCallout: function(error, messages) {
    var _error$responseJSON, _error$responseJSON$e;
    if (!(error !== null && error !== void 0 && (_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes(CUSTOM_ACCESS_DENIED_KEY))) {
      return false;
    }
    const message = messages === null || messages === void 0 ? void 0 : messages.find((message2) => message2.i18n.key === CUSTOM_ACCESS_DENIED_KEY);
    if (!message) {
      return false;
    }
    const {
      errorSummary
    } = error.responseJSON;
    const options = {
      type: "error",
      content: new CustomAccessDeniedErrorMessage({
        message: errorSummary,
        links: message.links
      })
    };
    this.showMessages(createCallout(options));
    return true;
  },
  _addForgotPasswordView: function() {
    const forgotPasswordLink = getForgotPasswordLink(this.options.appState, this.options.settings);
    if (forgotPasswordLink.length) {
      this.add('<div class="links-primary"></div>', {
        selector: ".o-form-button-bar"
      });
      this.add(Link, {
        selector: ".links-primary",
        options: forgotPasswordLink[0]
      });
    }
  },
  _addIdpView: function(idpButtons) {
    const idpDisplay = this.options.settings.get("idpDisplay");
    const isPrimaryIdpDisplay = idpDisplay && idpDisplay.toUpperCase() === "PRIMARY";
    this.add(signInWithIdps, {
      prepend: isPrimaryIdpDisplay,
      selector: isPrimaryIdpDisplay ? ".o-form-fieldset-container" : ".o-form-button-bar",
      options: {
        idpButtons,
        isPrimaryIdpDisplay
      }
    });
  },
  _shouldAddUsername: function(uiSchema) {
    return uiSchema.find((schema) => schema.name === "identifier") && this.settings.get("username");
  },
  _shouldApplyRememberMyUsername: function(uiSchema) {
    return uiSchema.find((schema) => schema.name === "identifier") && this.settings.get("features.rememberMe");
  },
  /**
   * When "Remember My Username" is enabled, we pre-fill the identifier
   * field with the saved userName cookie. The cookie would have been originally
   * saved when submitting the form previously.
   */
  _applyRememberMyUsername: function() {
    const cookieUsername = fn.getCookieUsername();
    if (cookieUsername) {
      this.model.set("identifier", cookieUsername);
    }
  }
});
var IdentifierView = BaseView.extend({
  Body,
  createModelClass: function() {
    const ModelClass = BaseView.prototype.createModelClass.apply(this, arguments);
    const identifierRequiredi18nKey = "error.username.required";
    const passwordRequiredi18nKey = "error.password.required";
    const props = ModelClass.prototype.props;
    const validate = (attr) => {
      const inlineErrors = {};
      const isEmptyIdentifier = props["identifier"] && !(attr !== null && attr !== void 0 && attr["identifier"]);
      const isEmptyPassword = props["credentials.passcode"] && !(attr !== null && attr !== void 0 && attr["credentials.passcode"]);
      if (isEmptyIdentifier && isCustomizedI18nKey(identifierRequiredi18nKey, this.settings)) {
        inlineErrors["identifier"] = loc(identifierRequiredi18nKey, "login");
      }
      if (isEmptyPassword && isCustomizedI18nKey(passwordRequiredi18nKey, this.settings)) {
        inlineErrors["credentials.passcode"] = loc(passwordRequiredi18nKey, "login");
      }
      return inlineErrors;
    };
    return ModelClass.extend({
      validate
    });
  },
  initialize: function() {
    this.Footer = IdentifierFooter.extend({
      showForgotPasswordLink: () => {
        const idpButtons = createIdpButtons(this.options);
        return !this.options.appState.isIdentifierOnlyView() && (!Array.isArray(idpButtons) || idpButtons.length === 0);
      }
    });
  },
  postRender: function() {
    BaseView.prototype.postRender.apply(this, arguments);
    const appState = this.options.appState;
    this.$el.find(".js-sign-up").click(function() {
      appState.trigger("invokeAction", FORMS.SELECT_ENROLL_PROFILE);
      return false;
    });
  }
});
export { IdentifierView as default };
